class Response {
  constructor(status, data, errors, isLoading) {
    this.status = status;
    this.data = data;
    this.errors = errors;
    this.isLoading = isLoading;
  }
}

const fetchData = async (
  url,
  method,
  data,
  auth = true,
  json = true,
  token
) => {
  const headers = {
    ...(["POST", "PUT", "PATCH"].includes(method) &&
      json && { "Content-Type": "application/json" }),
    ...(auth && {
      Authorization: `Token ${JSON.parse(
        localStorage.getItem("token") || token
      )}`,
      "x-gridkey-user-role": "advisor", // TODO - Replace this with the current gridkey user role
    }),
  };

  const requestOptions = {
    method,
    headers,
    ...(data && { body: json ? JSON.stringify(data) : data }),
  };

  try {
    const r = await fetch(url, requestOptions);
    const contentType = r.headers.get("Content-Type");

    let responseData;
    if (contentType && contentType.includes("application/json")) {
      responseData = await r.json();
    } else {
      responseData = await r.text();
    }

    if (r.status >= 200 && r.status < 300) {
      return new Response(r.status, responseData, undefined, false);
    } else {
      return new Response(r.status, undefined, responseData);
    }
  } catch (err) {
    return new Response(999, undefined, err);
  }
};

const downloadFiles = async (url, data, method) => {
  const requestOptions = {
    method,
    headers: {
      Authorization: `Token ${JSON.parse(localStorage.getItem("token"))}`,
      "x-gridkey-user-role": "advisor",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(url, requestOptions);
    return response;
  } catch (err) {
    console.error("Error downloading file:", err);
    throw err;
  }
};

export { fetchData, downloadFiles };
